export const AppStyles: any = {
    cardStyle: {
        width: '400px',
        margin: 'auto',
        marginTop: 20,
        textAlign: 'center',
        display: 'block',
    },
    logoStyle: { 
        marginTop: '20px', 
        marginBottom: '20px', 
        padding: '10px', 
        border: '1px solid black', 
        borderRadius: '50%' 
    }
}
